import Vue from 'vue'
import Router from 'vue-router'
import Help from '../components/Help'
import Home from '../components/Home'
import Submit from '../components/Submit'
import Queue from '../components/Queue'
import Task from '../components/Task'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },

    {
      path: '/help',
      name: 'Help',
      component: Help
    },

    {
      path: '/home',
      name: 'Home',
      component: Home
    },

    {
      path: '/submit',
      name: 'Submit',
      component: Submit
    },

    {
      path: '/queue',
      name: 'Queue',
      component: Queue
    },

    {
      path: '/task/:id',
      name: 'Task',
      component: Task
    }
  ]
})
